import React from 'react';

import finishImage from '../../../../assets/images/finish-registration.svg';

import { Container } from './styles';

interface FinishActivationProps {
  /** `true` quando o passo opcional de vínculo de WhatsApp foi concluído (0.34). */
  whatsappLinked?: boolean;
}

/**
 * O fim da ativação, e ele **não menciona aplicativo** (0.35).
 *
 * ⛔ **Aqui havia um botão para a Play Store, e ele apontava para o app errado.** O pacote
 * `com.cincoapp` é o `cinco-app-patients`, registrado como **descontinuado** no
 * `ARCHITECTURE.md` — o app do paciente em evolução é o `cinco-b2c`, que **não está
 * publicado**. Mandar o paciente para a loja era mandá-lo para um app que não serve, o que
 * é pior que não mandar a lugar nenhum. O `StoreLink` do `styles.ts` saiu junto.
 *
 * ⚠️ Diferença em relação à `/welcome` do usuário de equipe, que termina com um botão para o
 * painel: paciente não usa painel web. Enquanto não houver app publicado, o canal dele é o
 * **WhatsApp** — e é por isso que o texto do caso "pulou" aponta para a retentativa.
 *
 * ⓘ **Quem vinculou lê a confirmação aqui**, porque é a única que a pessoa recebe na hora: o
 * registro no `cinco_chat` não dispara mensagem nenhuma — a primeira só sai por template
 * aprovado pela Meta, ou depois de ela escrever primeiro. (O e-mail de "WhatsApp vinculado"
 * da 0.35 chega em seguida, e existe para outra finalidade: tornar um vínculo indevido
 * perceptível.)
 */
const FinishActivation: React.FC<FinishActivationProps> = ({
  whatsappLinked = false,
}) => {
  return (
    <Container>
      <img src={finishImage} alt="Cadastro concluído" />
      <h1>Cadastro concluído!</h1>
      <h2>A sua conta está criada.</h2>
      {whatsappLinked ? (
        <h2>
          O seu WhatsApp está vinculado: é por lá que a Cinco vai falar com
          você.
        </h2>
      ) : (
        <h2>
          Quando quiser receber o acompanhamento pelo WhatsApp, acesse
          saudecinco.com/patient/whatsapp e informe o seu e-mail — enviamos um
          link para você.
        </h2>
      )}
    </Container>
  );
};

export default FinishActivation;
